export const insertArrowsToButtons = () =>{
    let buttons = document.querySelectorAll(".button");
    if(buttons) {
       
        buttons.forEach(btn=>{
            let text = btn.innerText;
            let span = document.createElement("span");
            span.innerText = text;
            btn.textContent='';
            btn.appendChild(span)

            let img = document.createElement("img");
            img.src = themeUrl+"/src/img/arrow-btn.svg";
            img.alt = "button arrow";
            btn.appendChild(img);
        })
    }
}
